{
  "instances": {
    "caches": {
      "label": "캐시",
      "cache_manager": "캐시 관리자",
      "loading": "캐시 정보 불러오는 중...",
      "name": "이름",
      "no_caches_found": "캐시 정보를 찾을 수 없습니다."
    }
  }
}
